import React from 'react';
import { ContactIcon } from './style';

const ContactIconComponent = ({icon, size, marginRight}) => (
  <ContactIcon
    marginRight={marginRight}
    className="dds__icons"
    size={size}
    aria-hidden="true"
  >
    {icon}
  </ContactIcon>
);

export default ContactIconComponent;